import { PlotCreator } from "../core/view-object-creators/plot-creator";
import { UniversalDataPlot } from "../../../../web-visualizator";

export class UniversalPlotCreator extends PlotCreator {
  constructor(commonSettings) {
    super(commonSettings);
  }

  createPlotObject(settings) {
    return new UniversalDataPlot(settings);
  }
}
